import { closeModal, openModal } from '../../scripts/components/modals';
import { openMinicart } from '../../scripts/components/minicart';
import { execOnLoad } from '../../scripts/helpers';
import './engraving.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initMobileMenu = (context) => {
  const snippetContainer = context.classList.contains('.engraving__container')
    ? context
    : context.closest('.engraving__container');
  if (!snippetContainer) return;

  const modal = snippetContainer.querySelector('.modal');
  const engravingTextInput = document.getElementById('engravingText');
  const engravingPreview = snippetContainer.querySelector('.engraving__preview');

  const formatText = (text) => {
    let formattedText = '';
    for (let i = 0; i < text.length; i += 16) {
      formattedText += text.slice(i, i + 16) + '\n';
    }
    return formattedText;
  };

  engravingTextInput.addEventListener('input', function() {
    const formattedText = formatText(engravingTextInput.value);
    engravingPreview.textContent = formattedText;
  });

  document.getElementById('engraving__add-to-cart').addEventListener('click', function() {
    var selectedVariantId = this.getAttribute('data-variant-id');
    var parentProductId = document.querySelector('.engraving__parent-product').getAttribute('data-parent-product');
    var engravingText = document.getElementById('engravingText').value;
    var engravingUniqueID = document.getElementById('engravingUniqueId').value;

    var items = [
      { id: parseInt(selectedVariantId), quantity: 1, properties: { "Engraving": engravingText, '_UniqueId': engravingUniqueID }},
      { id: parseInt(parentProductId), quantity: 1, properties: { '_UniqueId': engravingUniqueID }}
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(response => response.json())
    .then(data => {
      closeModal(modal);
      openMinicart(true);
      const random = Math.floor(Math.random() * 1000);
      $('#engravingUniqueId').val(random);
      $('#uniqueId').val(random);
    })
    .catch(error => console.error(error));
  });
};

execOnLoad(window.dAgency.initMobileMenu, '.engraving__container');
